import { container, title } from 'assets/jss/material-kit-react.js'

const historyStyle = {
  section: {
    padding: '70px 0',
  },
  container,
  titleWrapper: {
    textAlign: 'center',
    marginBottom: '50px',
  },
  title: {
    ...title,
    marginBottom: '1rem',
    marginTop: '30px',
    minHeight: '32px',
    textDecoration: 'none',
    fontSize: '2.5rem',
    fontWeight: '700',
    color: '#333',
  },
  description: {
    fontSize: '1.125rem',
    lineHeight: '1.6',
    color: '#666',
    maxWidth: '600px',
    margin: '0 auto',
  },
  companyLink: {
    color: '#3949AB',
    fontWeight: '700',
    position: 'relative',
    textDecoration: 'none',
    borderBottom: '2px solid #3949AB',
    paddingBottom: '1px',
    transition: 'all 0.3s ease',
    '&:hover': {
      color: 'rgba(57, 73, 171, 0.8)',
      borderBottomColor: 'rgba(57, 73, 171, 0.8)',
      transform: 'translateY(-1px)',
      '&::after': {
        width: '100%',
      },
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: '-2px',
      left: '0',
      width: '0',
      height: '2px',
      background: 'linear-gradient(90deg, #3949AB, rgba(57, 73, 171, 0.6))',
      transition: 'width 0.3s ease',
    },
  },
}

export default historyStyle
